/**
 * Home Assistant 連携 API サービス
 *
 * デバイス → ユーザーのマッピング管理（フルアクセス権限を持つユーザーのみ）
 */

import { apiClient } from '@/api/client'
import type {
  HaDeviceMappingListResponse,
  HaDeviceMappingUpsert,
  HaDeviceMappingUpsertResponse,
  HaUnassignedDeviceListResponse,
} from '@/api/types/ha'

/**
 * マッピング一覧を取得
 */
export const getHaDeviceMappings = async (): Promise<HaDeviceMappingListResponse> => {
  const res = await apiClient.get('/ha/device-mappings')
  return res.data
}

/**
 * 未割当デバイス候補を取得
 */
export const getHaUnassignedDevices = async (): Promise<HaUnassignedDeviceListResponse> => {
  const res = await apiClient.get('/ha/unassigned-devices')
  return res.data
}

/**
 * マッピングを登録/更新（過去の未割当イベントをバックフィル）
 */
export const upsertHaDeviceMapping = async (request: HaDeviceMappingUpsert): Promise<HaDeviceMappingUpsertResponse> => {
  const res = await apiClient.put('/ha/device-mappings', request)
  return res.data
}

/**
 * マッピングを削除
 */
export const deleteHaDeviceMapping = async (deviceKey: string): Promise<{ message: string; device_key: string }> => {
  const res = await apiClient.delete(`/ha/device-mappings/${encodeURIComponent(deviceKey)}`)
  return res.data
}
